
import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="color-selector"
export default class extends Controller {
  static targets = ["input", "button"];

  connect() {

    console.log("CheckboxSelector connected");
    this.loadSelectedColors();
  }

  toggle(event) {
    const button = event.currentTarget;
    button.classList.toggle("active");
    button.classList.toggle("btn-primary");
    button.classList.toggle("btn-outline-primary");

    this.updateSelectedColors();
  }

  selectAll() {
    this.buttonTargets.forEach((button) => {
      button.classList.add("active", "btn-primary");
      button.classList.remove("btn-outline-primary");
    });
    this.updateSelectedColors();
  }

  selectNone() {
    this.buttonTargets.forEach((button) => {
      button.classList.remove("active", "btn-primary");
      button.classList.add("btn-outline-primary");
    });
    this.updateSelectedColors();
  }

  updateSelectedColors() {
    const selectedColors = this.buttonTargets
      .filter((button) => button.classList.contains("active"))
      .map((button) => button.dataset.color);
    this.inputTarget.value = selectedColors.join(",");
  }

  loadSelectedColors() {
    const selectedColors = this.inputTarget.value.split(",");
    this.buttonTargets.forEach((button) => {
      if (selectedColors.includes(button.dataset.color)) {
        button.classList.add("active", "btn-primary");
        button.classList.remove("btn-outline-primary");
      }
    });
  }
}

